/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import { get, isEmpty } from "lodash";
import { Box } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";
import ExpandableContent from "src/components/ExpandableContent";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { ModalProvider } from "src/contexts/withModal";
import { useShouldExpandObjectives } from "src/hooks/useHighlightedObjectiveId";
import TeamDetailsStrategyTable from "src/pages/TeamPage/sub-components/TeamDetailsPanel/TeamDetailsStrategyTable";

import withTeam from "../DataProviderHOCs/withTeam";

const CanvTeamObjectives = withTeam(({ team }) => {
  const workspace = useWorkspace();
  const objectiveIds = get(team, "objectiveIds");
  const disableGroupStrategy = get(
    workspace,
    "config.allocation.disableGroupStrategy",
    false
  );
  if (disableGroupStrategy) {
    return null;
  }
  const shouldExpandObjectives = useShouldExpandObjectives();

  return (
    <ModalProvider>
      {isEmpty(objectiveIds) ? (
        <p>Team has no objectives</p>
      ) : (
        <div style={{ overflow: "auto" }}>
          <Box
            borderRadius={2}
            boxBorder="default"
            p="r"
            mb="r"
            bg="white"
            width="100%"
          >
            <ExpandableContent initialExpanded={shouldExpandObjectives}>
              <TeamDetailsStrategyTable team={team} />
            </ExpandableContent>
          </Box>
        </div>
      )}
    </ModalProvider>
  );
});

CanvTeamObjectives.propTypes = {
  channel: PropTypes.string.isRequired,
};

export default CanvTeamObjectives;
